import { render, staticRenderFns } from "./SendAct.vue?vue&type=template&id=6a8f50d4"
import script from "./SendAct.vue?vue&type=script&lang=js"
export * from "./SendAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports